module.exports = __webpack_public_path__ + "img/wb8@2x.3e2066da.png";